angular.module("accordionSearchFiducianti.components", [])
    .component("accordionSearchFiducianti", {
        templateUrl: "ng/components/accordionSearchFiducianti/accordionSearchFiducianti.view.html",
        bindings: {
            listPf: '=',
            isTitolari: '<',
            isFiducianti: '<',
            domini: '<',
            startQuestionario: '<',
            checkComponent: '&',
            externalLink: '<',
            readOnly: '<'
        },
        controller: SearchFiduciantiController,
        controllerAs: "accordionSearchFiduciantiCtrl"
    })

function SearchFiduciantiController(
    FinancialCustomer,
    $financialApiService,
    Pf,
    $rootScope,
    Documento,
    Sede,
    $timeout,
    $modalService,
    $typeDomainService,
    validationService,
    $scope,
    FileUploader,
    $simulationService,
    $uniService,
    $download,
    $configService,
    $portalService
) {

    var self = this;

    self.$onInit = function () {
        self.loaderRemove = [];
        self.$portalService = $portalService;
        self.testDati = {
            value: true,
            error: ""
        }
        self.validationObj = {
            documentDate: {
                disabledDays: [0],
                disabledDates: [
                    "01-01",
                    "06-01",
                    "25-04",
                    "01-05",
                    "02-06",
                    "15-08",
                    "01-11",
                    "08-12",
                    "25-12",
                    "26-12"
                ]
            }
        };
        self.tomorrow = moment()
            .add(1, "days")
            .format("DD/MM/YYYY");
        self.today = self.getTodaysDate();
        self.linkPep = '/uni/download/service-infos/' +
            encodeURIComponent('GLOSSARIO') + '/'
        self.searchObj = {}
        self.dropdown = {};
        $scope.forms = {};
        self.documentUpload = [];
        self.comuni = $rootScope.comuniMap;
        self.comuniNsil = $rootScope.mapComuniSoppressi;
        self.nazioni = $rootScope.nazioniEstere;
        self.nationCitizenship = self.nazioni.filter(
            function (element) {
                return !element.deleted
            }).map(function (element) {
                return element.name.toUpperCase();
            }).sort();
        self.nationsList = self.nazioni.filter(
            function (x) {
                return x.description != '086' && x.description != '139' && x.description != 'T86'
            }
        );
        self.listaNazioni = self.nationsList;
        self.listaProvince = self.comuni
            .map(function (comune) {
                return comune.sigla;
            })
            .filter(function (siglaComune) {
                return siglaComune != "";
            })
            .sort()
            .reduce(function (result, nextItem) {
                return result.includes(nextItem) ? result : result.concat(nextItem);
            }, []);

        self.listaProvince.push("EE")
        getListaDocumenti();
        createCfFromFidEsteri();
    }

    self.downloadInfoPep = () => {

        $download.getGenericDownload(self.linkPep)
            .then(function (response) {
                console.log(response);
            })
    }

    self.getTodaysDate = function () {

        return moment().format("DD/MM/YYYY");
    }

    var getListaDocumenti = function () {

        $typeDomainService
            .getDomainSet("RI_DROPDOWN_DOMAINS", "DOCUMENT_TYPE")
            .then(function (response) {
                self.dropdown.tipiDocumento = response.domainList;
                for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
                    if (self.dropdown.tipiDocumento[i].value == "CAE") {
                        self.dropdown.tipiDocumento[i].order = 40;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "CAI") {
                        self.dropdown.tipiDocumento[i].order = 10;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "CIE") {
                        self.dropdown.tipiDocumento[i].order = 20;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "NCE") {
                        self.dropdown.tipiDocumento[i].order = 30;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAM") {
                        self.dropdown.tipiDocumento[i].order = 50;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAS") {
                        self.dropdown.tipiDocumento[i].order = 80;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "PAT") {
                        self.dropdown.tipiDocumento[i].order = 60;
                    }
                    if (self.dropdown.tipiDocumento[i].value == "UCO") {
                        self.dropdown.tipiDocumento[i].order = 70;
                    }

                }
            });
    }


    self.searchPF = function (searchForNdg) {
        self.searching = true;
        self.openSectionUpgradePf = false;
        if (self.userAlreadyAdded(searchForNdg)) {
            $rootScope.$broadcast("addAlert", {
                text: "ALREADY_ADDED"
            });
            return
        }
        self.searchObj.pfcf = self.searchObj.pfcf && self.searchObj.pfcf.toUpperCase();
        self.PFresultsShown = true;
        var customer = FinancialCustomer.build({
            cf: self.searchObj.pfcf,
            ndg: self.searchObj.ndg,
        });

        customer.metadata = null;
        $financialApiService
            .getCustomerByFilter(customer, true)
            .then(function (response) {

                if (response.success && response.listAppCustomer && response.listAppCustomer[0]) {
                    $financialApiService
                        .getSearchRiUserG(response.listAppCustomer[0])
                        .then(function (listAppCustomer) {
                            if (listAppCustomer.success) {
                                listAppCustomer.appCustomerUser.metadata.riUserG.sedeLegale.stato = listAppCustomer.appCustomerUser.metadata.riUserG.sedeLegale.statoEsteso
                                if (listAppCustomer.appCustomerUser.metadata.riUserG.isEstero) {
                                    var codCityOfBirth = self.nazioni.find(function (element) {
                                        if (!listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato) {
                                            if (!!listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.statoEsteso && !!listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.statoEsteso.name) {
                                                listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato = listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.statoEsteso
                                            } else if (!!listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.nazione) {
                                                listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato = {
                                                    name: listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.nazione
                                                }
                                            }
                                        }
                                        return element.name.toUpperCase() == listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.stato.name.toUpperCase()
                                    }).value
                                    if (!listAppCustomer.appCustomerUser.metadata.riUserG.sesso) {
                                        listAppCustomer.appCustomerUser.metadata.riUserG.sesso = "m"
                                    }
                                    listAppCustomer.appCustomerUser.metadata.riUserG.cf = validationService.createCf(listAppCustomer.appCustomerUser.metadata.riUserG.nome, listAppCustomer.appCustomerUser.metadata.riUserG.cognome, listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita.data, listAppCustomer.appCustomerUser.metadata.riUserG.sesso, codCityOfBirth)
                                }

                                if (listAppCustomer.appCustomerUser.metadata.riUserG.domicilioDiverso && listAppCustomer.appCustomerUser.metadata.riUserG.domicilio) {
                                    listAppCustomer.appCustomerUser.metadata.riUserG.domicilio.stato = listAppCustomer.appCustomerUser.metadata.riUserG.domicilio.statoEsteso

                                }

                                var comuni = self.comuni.concat(self.comuniNsil);
                                var newUser = Pf.build(listAppCustomer.appCustomerUser.metadata.riUserG).setDefaultPfValues(self.nazioni, comuni);
                                listAppCustomer.appCustomerUser.metadata.riUserG.datiNascita = newUser.datiNascita;
                                listAppCustomer.appCustomerUser.metadata.riUserG.sesso = newUser.sesso;
                                newUser = convertDateToFid(listAppCustomer.appCustomerUser.metadata.riUserG)
                                var newTit = createNewFiduciario(newUser);
                                self.tempPerson = newTit
                                self.searchFinish = false;
                                self.PFresultsShown = true;
                                self.searching = false;
                            } else {

                            }
                            self.searchObj.pfcf = "";
                            self.searchObj.ndg = "";
                        })
                        .catch(function (error) {
                            console.log(error);
                            self.searchFinish = false;
                            self.PFresultsShown = true;
                            self.searching = false;
                            self.searchObj.pfcf = "";
                            self.searchObj.ndg = "";
                        })

                } else {
                    if (!searchForNdg) {
                        var tempUser = {
                            cf: self.searchObj.pfcf
                        }
                        var comuni = self.comuni.concat(self.comuniNsil);
                        tempUser = Pf.build(tempUser).setDefaultPfValues(self.nazioni, comuni);
                        var newUser = convertDateToFid(tempUser)
                        var newTit = createNewFiduciario(newUser);
                        self.tempPerson = newTit
                        self.searchFinish = false;
                        self.PFresultsShown = true;
                        self.searching = false;
                    }
                    self.searchObj.pfcf = "";
                    self.searchObj.ndg = "";

                }


            })
            .catch(function (error) {
                console.log(error);
                self.searchFinish = true;
                self.PFresultsShown = true;
                self.searching = false;
            })

    }

    var convertDateToFid = function (user) {
        var temp = {
            nome: user.nome,
            cognome: user.cognome,
            cf: user.cf,
            datiNascita: user.datiNascita,
            sedeLegale: user.sedeLegale,
            ndg: user.ndg,
            domicilioDiverso: user.domicilioDiverso,
            domicilio: user.domicilio,
            isEstero: user.isEstero,
            documento: user.documento,
            sesso: user.sesso,
            cittadinanza: user.cittadinanza
        }

        return temp;

    }

    self.annulla = function (index) {
        self.listPf[index].annullatoFe = true;
        self.listPf[index].riattivatoFe = false;
        self.checkComponent();
    }

    self.riabilita = function (index) {
        self.listPf[index].riattivatoFe = true;
        self.listPf[index].annullatoFe = false;
        self.checkComponent();
    }

    self.userAlreadyAdded = function (searchFromNdg) {

        if (searchFromNdg) {
            return self.listPf.some(x => {
                return x.ndg == self.searchObj.ndg
            })

        } else {
            return self.listPf.some(x => {
                return x.cf == self.searchObj.pfcf
            })
        }
    }

    var createNewFiduciario = function (dateOfRest) {
        var newFiducianti = {
            cf: dateOfRest && dateOfRest.cf || null,
            cognome: dateOfRest && dateOfRest.cognome || null,
            data: dateOfRest && dateOfRest.data || null,
            cittadinanza: dateOfRest && dateOfRest.cittadinanza || null,
            datiNascita: dateOfRest && dateOfRest.datiNascita,
            sesso: dateOfRest && dateOfRest.sesso,
            description: "fiducianti",
            documento: dateOfRest && Documento.build(dateOfRest.documento) || Documento.build(),
            domicilio: dateOfRest && dateOfRest.domicilio || null,
            domicilioDiverso: dateOfRest && dateOfRest.domicilioDiverso || false,
            editable: false,
            id: null,
            ndg: dateOfRest && dateOfRest.ndg || null,
            nome: dateOfRest && dateOfRest.nome || null,
            pep: {
                carica: self.domini.carica,
                origineFondi: self.domini.origineFondi,
                relazione: self.domini.relazione,
                id: "pep_base",
                description: "pep_base",
                visible: false,
                editable: false,
                pep: null,
                origineFondiDescr: null,
                paeseOrigine: null,
                pepFinanziamenti: false,
                relazioneDescr: null
            },
            dataLettera: null,
            ragioneSociale: null,
            sedeLegale: Sede.build(dateOfRest && dateOfRest.sedeLegale),
            visible: false,
            isEstero: dateOfRest && dateOfRest.isEstero

        }
        self.supportModel = {
            ruolo: null,
            professione: null,
            professionePrec: null,
            relazionePep: null,
            originePatrimonio: null,
            settore: null,
            areaGeoSvolgimento: null,
            relazioneTitCliente: null,
            caricaIstituzionale: null,
            originePatrimonioPEP: null
        }

        return newFiducianti;

    }

    self.addPfEstero = function () {
        self.tempPerson = createNewFiduciario();
        self.disableButtonAddEstero = true;
        self.openSectionUpgradePf = true;
    }

    self.closeSectionUpdatePf = function () {
        self.disableButtonAddEstero = false;
        self.openSectionUpgradePf = false;
        self.tempPerson = {};
    }

    self.completaPfEstero = function () {
        self.tempPerson.cf = validationService.createCf(self.tempPerson.nome, self.tempPerson.cognome, self.tempPerson.data, self.tempPerson.sesso, self.tempPerson.datiNascita.stato.value);
        self.tempPerson.datiNascita.comune = self.tempPerson.datiNascita.stato.name;
        var comuni = self.comuni.concat(self.comuniNsil);
        var temporanyUser = Pf.build(self.tempPerson).setDefaultPfValues(self.nazioni, comuni);
        var newUser = convertDateToFid(temporanyUser)
        var newTit = createNewFiduciario(newUser);
        newTit.isEstero = true;
        self.listPf.push(newTit)
        self.disableButtonAddEstero = false;
        self.openSectionUpgradePf = false;
        self.tempPerson = {};
        self.checkComponent();
    }

    self.addPfToList = function (tempPerson) {
        self.listPf.push(tempPerson)
        self.tempPerson = null;
        self.PFresultsShown = false;
        self.checkComponent();

    }

    self.editPf = function (pf) {
        self.userDaCensire = pf;
        self.enableModal = true;
        self.createListComuniNascita(self.userDaCensire.datiNascita.provincia);
        self.createListComuniRilascio(self.userDaCensire.documento.provincia);
        self.createListDocumenti(self.userDaCensire.documento.tipo);
        self.verifyDate();
        setDefaultDate();
        $timeout(function () {
            $modalService.openModal('arricchimentoTFid-modal');
            $("#footerInstant").css("z-index", "-1");
            $('.financial-leasing__footer').css("z-index", "-1");
        }, 300)
    }

    self.undoDocumentChanges = function () {
        $modalService.closeModal("arricchimentoTFid-modal");
        self.enableModal = false;
        $("#footerInstant").css("z-index", "2");
        $('.financial-leasing__footer').css("z-index", "2");
        jQuery('.mCSB_scrollTools').css("z-index", "2");
        self.listaComuniNascita = [];
        self.listaNomeComuniRilascio = [];
    }

    self.createListComuniNascita = function (provincia) {
        var comuni = self.comuni.concat(self.comuniNsil);
        self.listaComuniNascita = comuni
            .filter(function (comune) {
                return comune.sigla == provincia;
            });
    }

    self.createListComuniRilascio = function (provincia, resetComune) {

        if (provincia != 'EE' && provincia != 'SE') {
            self.listaNomeComuniRilascio = self.comuni
                .filter(function (comune) {
                    return comune.sigla == provincia
                });
        }
        if (resetComune) {
            self.userDaCensire.documento.luogoEsteso = null;
            self.userDaCensire.documento.luogo = null;
            self.userDaCensire.documento.statoEsteso = {};

        }
    }

    self.createListDocumenti = function (tipo, changedDoc) {
        var documento = self.dropdown.tipiDocumento.find(x => {
            return x.value == tipo
        })
        self.showDownloadExample = documento && documento.additionalProperty == 1 ? true : false;
        generateLinkExampleDoc(tipo);
        self.listaNomeRilascio = Documento.getEntiRilascio(tipo)
        if (changedDoc) {
            self.documentUpload = [];
            self.userDaCensire.documento = Documento.build({ tipo: tipo })
        }
        self.refreshRegex = true;
        $timeout(function () {
            self.refreshRegex = false;
        }, 200)

        if (tipo == 'CAE' || tipo == 'UCO') {


            if (tipo == 'UCO') {
                self.disableEnteRilascioProvinciaUco = true;
                self.userDaCensire.documento.provincia = 'RM';
                self.createListComuniRilascio(self.userDaCensire.documento.provincia, true)
                var roma = self.comuni
                    .find(function (comune) {
                        return comune.nome.toLowerCase() == 'roma';
                    });
                self.userDaCensire.documento.luogoEsteso = roma;
                self.userDaCensire.documento.enteRilascio = self.listaNomeRilascio.find(x => {
                    return x.name.toUpperCase() == 'MINISTERO'
                })
            } else {
                self.disableEnteRilascioProvinciaCae = true;
                self.userDaCensire.documento.provincia = 'EE'
                self.createListComuniRilascio(self.userDaCensire.documento.provincia)
            }



        } else {
            self.disableEnteRilascioProvinciaCae = false;
            self.disableEnteRilascioProvinciaUco = false;
        }

        if (self.userDaCensire.documento && self.userDaCensire.documento.tipo) {


            if (tipo == 'UCO') {
                self.userDaCensire.documento.enteRilascio = self.listaNomeRilascio.find(x => {
                    return x.name.toUpperCase() == 'MINISTERO'
                })
            } else {
                self.userDaCensire.documento.enteRilascio = self.listaNomeRilascio[0];
            }
        } else {
            self.userDaCensire.documento.enteRilascio = null
        }

        if (self.userDaCensire.ndg && !self.isPagoDopo && changedDoc && $portalService.isAra()) {
            $financialApiService
                .getIdentityDocument(
                    self.userDaCensire.ndg,
                    self.userDaCensire.documento.tipo
                )
                .then(function (response) {
                    if (response.success) {
                        self.userDaCensire.documento.dataRilascio =
                            response.document.dataRilascio;
                        self.userDaCensire.documento.dataScadenza =
                            response.document.dataScadenza;
                        self.userDaCensire.documento.luogoEsteso = {
                            nome: response.document.luogo,
                        };
                        self.userDaCensire.documento.luogo = response.document.luogo
                        self.userDaCensire.documento.enteRilascio.name =
                            response.document.enteRilascio;
                        self.userDaCensire.documento.provincia =
                            response.document.provincia;
                        self.userDaCensire.documento.numero = response.document.numero;
                        self.userDaCensire.documento.id = response.document.id;

                        if ((response.document.provincia == "EE" || response.document.provincia == "SE") && response.document.luogo) {
                            self.userDaCensire.documento.statoEsteso = self.listaNazioni
                                .find(x => {
                                    return x.name.toUpperCase() == response.document.luogo.toUpperCase();
                                })
                        } else {
                            self.userDaCensire.documento.statoEsteso = {
                                name: 'ITALIA',
                                value: 'Z999',
                                description: '086'
                            }
                        }
                    }
                    $timeout(function () {

                    }, 1000)
                })
                .catch(function (error) {
                    console.log(error);
                });

        }
    }

    self.verifyDate = function () {
        var sesso = "";
        //calculateFakeCf(indice)
        if (!self.userDaCensire.cf) {
            sesso = self.userDaCensire.sesso
        } else {
            var giornoNascita = self.userDaCensire.cf && self.userDaCensire.cf.substring(9, 11);
            sesso = giornoNascita > 40 ? 'F' : 'M'
        }
        var codCat = "";
        if (self.userDaCensire.datiNascita.provincia != 'EE') {
            var comuni = self.comuni.concat(self.comuniNsil);
            codCat = self.userDaCensire.datiNascita.comune &&
                comuni.find(function (element) {
                    return element.nome.toUpperCase() == self.userDaCensire.datiNascita.comune.toUpperCase()
                }).codiceCatastale;
            if (!codCat) {
                codCat = self.userDaCensire.datiNascita.luogoEsteso && self.userDaCensire.datiNascita.luogoEsteso.nome &&
                    comuni.find(function (element) {
                        return element.nome.toUpperCase() == self.userDaCensire.datiNascita.luogoEsteso.nome.toUpperCase()
                    }).codiceCatastale;

            }
        } else {
            codCat = self.nazioni.find(function (element) {
                return element.name.toUpperCase() == self.userDaCensire.datiNascita.stato.name.toUpperCase();
            }).value
        }
        self.testDati = validationService.checkCfWithFieds(
            self.userDaCensire.cf,
            self.userDaCensire.nome,
            self.userDaCensire.cognome,
            self.userDaCensire.datiNascita.data,
            sesso,
            codCat
        );

    };


    self.validateForm = function () {

        return $scope.forms.genericForm &&
            $scope.forms.genericForm.$valid &&
            (self.testDati && self.testDati.value) &&
            self.userDaCensire &&
            self.userDaCensire.documento &&
            !!self.userDaCensire.documento.uploadedDoc && !!self.userDaCensire.documento.uploadedDoc.length
    }

    var setDefaultDate = function () {
        self.documentUpload = [];
        if (self.userDaCensire.documento.idImgDocumentoFront) {
            var temp = {
                name: '',
                type: self.userDaCensire.documento.tipo,
                selected: false,
                side: "front",
                typeDocument: self.userDaCensire.documento.tipo,
                downloadLink: "",
                cdDoc: self.userDaCensire.documento.tipo,
                id: null,
                downloadKey: self.userDaCensire.documento.idImgDocumentoFront
            };
            if (self.userDaCensire.documento && !!!self.userDaCensire.documento.uploadedDoc) {
                self.userDaCensire.documento.uploadedDoc = [];

            }
            self.userDaCensire.documento.uploadedDoc.push(temp);
            self.userDaCensire.documento.idImgDocumentoFront = null;
        }
        // if (self.userDaCensire.documento.idImgDocumentoCfFront) {
        //     var temp = {
        //         name: '',
        //         type: 'CF',
        //         selected: false,
        //         side: "front",
        //         typeDocument: 'CF',
        //         downloadLink: "",
        //         cdDoc: 'CF',
        //         id: self.userDaCensire.documento.idImgDocumentoCfFront,
        //         downloadKey: self.userDaCensire.documento.idImgDocumentoCfFront
        //     };
        //     self.documentUpload.push(temp);

        // }

        if ((self.userDaCensire.documento.provincia == "EE" || self.userDaCensire.documento.provincia == "SE") && self.userDaCensire.documento.luogo) {
            self.userDaCensire.documento.statoEsteso = self.nationsList
                .find(x => {
                    return x.name.toUpperCase() == self.userDaCensire.documento.luogo.toUpperCase()
                })
        } else {
            self.userDaCensire.documento.statoEsteso = {
                name: 'ITALIA',
                value: 'Z999',
                description: '086'
            }
        }

        self.supportModel = {
            ruolo: null,
            professione: null,
            professionePrec: null,
            relazionePep: null,
            originePatrimonio: null,
            settore: null,
            areaGeoSvolgimento: null,
            relazioneTitCliente: null,
            caricaIstituzionale: null,
            originePatrimonioPEP: null
        }
        // inserire qui le funzioni per il popolamento dei dati già valorizzati
        popolateDefaultValue();
    }

    var popolateDefaultValue = function () {
        self.supportModel.relazioneTitCliente = self.userDaCensire.relazioneTitCli && self.userDaCensire.relazioneTitCli.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.professione = self.userDaCensire.professione && self.userDaCensire.professione.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.professionePrec = self.userDaCensire.professionePrec && self.userDaCensire.professionePrec.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.settore = self.userDaCensire.settore && self.userDaCensire.settore.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.areaGeoSvolgimento = self.userDaCensire.area && self.userDaCensire.area.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.originePatrimonio = self.userDaCensire.originePatrimonio && self.userDaCensire.originePatrimonio.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.caricaIstituzionale = self.userDaCensire.pep && self.userDaCensire.pep.carica && self.userDaCensire.pep.carica.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.relazionePep = self.userDaCensire.pep && self.userDaCensire.pep.relazione && self.userDaCensire.pep.relazione.find(function (sel) {
            return sel.selected == true;
        })

        self.supportModel.originePatrimonioPEP = self.userDaCensire.pep && self.userDaCensire.pep.origineFondi && self.userDaCensire.pep.origineFondi.find(function (sel) {
            return sel.selected == true;
        })
    }

    self.handleChange = function (tipo, subType, valueSelected) {
        if (subType) {
            self.userDaCensire[tipo][subType].forEach(function (element) {
                if (element.value == valueSelected.value) {
                    element.selected = true;
                } else {
                    element.selected = false;
                }
            })

        } else {
            self.userDaCensire[tipo].forEach(function (element) {
                if (element.value == valueSelected.value) {
                    element.selected = true;
                } else {
                    element.selected = false;
                }
            })
        }

        if (tipo === 'professione') {
            if (valueSelected.name === "Casalinga" || valueSelected.name === "Pensionato" || valueSelected.name === "Non occupato") {
                self.enablePreviusJob = true;
            } else {
                self.enablePreviusJob = false;
            }
        }
    }

    self.savePfData = function (pf) {
        var index = self.listPf.findIndex(x => {
            return x.cf == pf.cf
        })
        $rootScope.$broadcast("pageLoader", {
            action: "OPEN"
        });
        //Solo ai fini della stampa del documento metto in Uppercase nome e cognome e numero documento
        pf.nome = pf.nome && pf.nome.toUpperCase();
        pf.cognome = pf.cognome && pf.cognome.toUpperCase();
        pf.documento.numero = pf.documento.numero && pf.documento.numero.toUpperCase();

        if (self.externalLink) {
            $rootScope.$broadcast("pageLoader", {
                action: "CLOSE"
            });
            pf.isOk = true;
            self.listPf[index] = pf;
            $modalService.closeModal("arricchimentoTFid-modal");
            self.enableModal = false;
            $("#footerInstant").css("z-index", "2");
            $('.financial-leasing__footer').css("z-index", "2");

        } else {

            pf.residenza = pf.sedeLegale;
            pf.residenza.statoEsteso = pf.residenza.stato;
            $financialApiService.updatePersonalActivityDigital(null, Pf.build(pf), false)
                .then(function (response) {
                    self.enableLoader = false;
                    $rootScope.$broadcast("pageLoader", {
                        action: "CLOSE"
                    });
                    if (!response.success) {
                        console.log(response)
                        self.listPf[index].isOk = false;
                    } else {
                        pf.isOk = true;
                        self.listPf[index] = pf;
                        $modalService.closeModal("arricchimentoTFid-modal");
                        self.enableModal = false;
                        $("#footerInstant").css("z-index", "2");
                        $('.financial-leasing__footer').css("z-index", "2");
                    }
                    self.checkComponent();
                })
                .catch(function (error) {
                    console.log(error);
                    self.listPf[index].isOk = false;
                    $rootScope.$broadcast("pageLoader", {
                        action: "CLOSE"
                    });
                    self.checkComponent();

                })

        }

        self.checkComponent();

    }

    self.removePf = function (pf, indice) {


        self.loaderRemove[indice] = true;
        $uniService.
            deleteDocsPfAdv(self.startQuestionario.id, pf.cf)
            .then(response => {
                if (response.success) {
                    self.listPf.splice(indice, 1);
                    self.checkComponent();

                }
                self.loaderRemove[indice] = false;
            })
            .catch(error => {
                self.loaderRemove[indice] = false;
                console.log(error);
            })
    }

    // sezione upload
    self.uploader = new FileUploader({
        url: "",
        headers: {
            "Access-Control-Allow-Origin": "*",
            Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
            "App-Name": $rootScope.portalName,
        },
    });

    self.uploadDataFunc = function (item, index, privacy, type, side) {
        var document =
            arguments.length > 3 && arguments[3] !== undefined ?
                arguments[3] :
                false;
        if (item) {
            self.uploadData = item;
        }
        self.typeTempDocument = type;
        self.isPrivacyUpload = privacy;
        self.uploadDocumenti = document;
        self.currentCodeTypeNameIndex = index;
        self.sideUploaded = side;
    };
    self.finalUpload = function (item) {
        console.log("calling finalUpload");
        var url =
            $configService.getAppConfig().url +
            "/uni/upload/service-infos///FINANCIAL_PD";

        for (var int = 0; int < self.uploader.queue.length; int++) {
            self.uploader.queue[int].url = url;
        }
        var fileFront = document.querySelector(
            "#uploadInput_front").files[0];
        var fileBack = document.querySelector(
            "#uploadInput_back").files[0];
        var file;
        if (fileFront) {
            file = fileFront;
        } else {
            file = fileBack;
        }
        var tipo = self.userDaCensire.documento.tipo;
        var reader = new FileReader();
        var fronte = self.sideUploaded == "front" ? true : false;
        reader.onload = function (event) {
            var formData = new FormData();
            jQuery("#uploadInput_front").val("");
            jQuery("#uploadInput_back").val("");
            appendToForm(formData, "file", file);
            appendToForm(formData, "type", "GENERAL_PERSONAL_DOCUMENTS");
            appendToForm(formData, "cdDoc", tipo);
            appendToForm(formData, "filename", file.name);
            appendToForm(formData, "idPratica", self.startQuestionario.id);
            appendToForm(formData, "personal", true);
            appendToForm(formData, "fronte", fronte);
            appendToForm(formData, "cfSoggetto", self.userDaCensire.cf);
            appendToForm(formData, "ndgSoggetto", self.userDaCensire.ndg);

            $uniService
                .uploadDocOnAdv(formData)
                .then(function (response) {
                    if (!response.success) {
                        self.visualProgBarDoc = false;
                        self.disabledForUploadingInProgress = false;
                        if (self.sideUploaded == "front") {
                            self.disabeldUploadFront = false;
                        } else {
                            self.disabeldUploadBack = false;
                        }
                        $rootScope.$broadcast("addAlert", {
                            text: "ERROR_UPLOAD"
                        });

                        return;
                    }

                    $timeout(function () {
                        var temp = {
                            name: file.name,
                            type: "imgDocument",
                            selected: false,
                            side: self.sideUploaded,
                            typeDocument: self.userDaCensire.documento.tipo,
                            downloadLink: "",
                            cdDoc: self.userDaCensire.documento.tipo,
                            id: response.id,
                            imgDocumentoFront: response.downloadKey,
                            downloadKey: response.downloadKey
                        };


                        if (self.sideUploaded == "front") {
                            self.disabeldUploadFront = true;
                        } else {
                            self.disabeldUploadBack = true;
                        }

                        if (self.userDaCensire.documento && !!!self.userDaCensire.documento.uploadedDoc) {
                            self.userDaCensire.documento.uploadedDoc = [];
                        }

                        self.userDaCensire.documento.uploadedDoc.push(temp);

                        self.disableInput = false;

                        self.visualProgBarDoc = false;
                        if (self.sideUploaded == "front") {
                            self.userDaCensire.documento.idImgDocumentoFront = response.downloadKey;
                        } else {
                            self.userDaCensire.documento.idImgDocumentoBack = response.downloadKey;

                        }

                        $timeout(function () {
                            self.disabledForUploadingInProgress = false;
                        }, 1000);
                    }, 40);
                })
                .catch(function (error) {
                    self.visualProgBarDoc = false;
                    self.disabledForUploadingInProgress = false;
                    if (self.sideUploaded == "front") {
                        self.disabeldUploadFront = false;
                    } else {
                        self.disabeldUploadBack = false;
                    }
                });

        };
        if (file) {
            reader.readAsArrayBuffer(file);
        }
    };
    self.uploader.onAfterAddingFile = function (fileItem) {
        self.disabledForUploadingInProgress = true;
        console.log("fileItem", fileItem);
        self.progresso = 0;
        if (fileItem.file.size > 26214400) {
            $rootScope.$broadcast("addAlert", {
                text: "MAXIMUM_FILE_SIZE_EXCEEDED",
            });
            fileItem.remove();
            jQuery("#uploadInput_back").val("");
            jQuery("#uploadInput_front").val("");
        }
        var fileName = fileItem.file.name;
        if (
            fileName.toLowerCase().indexOf(".png") > -1 ||
            fileName.toLowerCase().indexOf(".jpg") > -1 ||
            fileName.toLowerCase().indexOf(".jpeg") > -1 ||
            fileName.toLowerCase().indexOf(".tiff") > -1 ||
            fileName.toLowerCase().indexOf(".pdf") > -1 ||
            fileName.toLowerCase().indexOf(".zip") > -1
        ) {
            self.uploader.queue[0].progress = 100;

            self.visualProgBarDoc = true;

            $timeout(function () {
                self.progresso = 100;
            }, 500);
        } else {
            fileItem.remove();
            jQuery("#uploadInput_back").val("");
            jQuery("#uploadInput_front").val("");
            $rootScope.$broadcast("addAlert", {
                text: "FORMAT_NOT_SUPPORTED",
            });
            self.disabledForUploadingInProgress = false;
        }
    };

    self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info("onAfterAddingAll", addedFileItems);
        self.finalUpload(self.uploadData);
    };

    self.uploader.onBeforeUploadItem = function (item) {
        item.file.name = window.encodeURIComponent(item.file.name);
        item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
        self.disableInput = true;
    };

    self.uploader.onProgressItem = function (fileItem, progress) {
        self.uploadCompleted = false;
    };

    self.uploader.onProgressAll = function (progress) { };

    self.uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
    ) { };

    self.uploader.onErrorItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        console.info("onErrorItem", fileItem, response, status, headers);
        jQuery("#uploadInput_back").val("");
        jQuery("#uploadInput_front").val("");
        $rootScope.$broadcast("addAlert", {
            text: "ERROR_UPLOADING_FILE",
        });

        self.disableInput = false;
        $timeout(function () {
            self.visualProgBarDoc = false;
        }, 4000);

        fileItem.remove();
        jQuery("#uploadInput_back").val("");
        jQuery("#uploadInput_front").val("");
    };

    self.uploader.onCancelItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        console.log(status);
    };

    self.uploader.onCompleteItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        console.info("onCompleteItem", fileItem, response, status, headers);
        if (
            response &&
            response.uploadFileServicePojo &&
            response.uploadFileServicePojo.success
        ) {

        }
        self.uploader.queue = [];

        self.disableInput = false;
        $timeout(function () {
            self.visualProgBarDoc = false;

            self.disabledForUploadingInProgress = false;
        }, 4000);
        jQuery("#uploadInput_back").val("");
        jQuery("#uploadInput_front").val("");
    };

    self.uploader.onCompleteAll = function () {
        console.info("onCompleteAll");
        self.uploadCompleted = true;
    };

    self.uploader.onSuccessItem = function (
        fileItem,
        response,
        status,
        headers
    ) {
        self.uploading = false;
    };

    self.check = function (el) {
        el.selected = !el.selected;
    };

    self.trashCanEnabledDoc = function () {
        return !!self.userDaCensire &&
            !!self.userDaCensire.documento &&
            !!self.userDaCensire.documento.uploadedDoc &&
            self.userDaCensire.documento.uploadedDoc.some(function (element) {
                return element.selected == true;
            })
    }

    self.deletePrivacyDocument = function () {
        self.progresso = 100;

        self.visualProgBarDoc = true;
        var temp = self.userDaCensire.documento.uploadedDoc.filter(x => {
            return x.selected == true;
        });
        temp.forEach(function (element) {
            $simulationService
                .deleteChecklistFileAdv(element.id)
                .then(function (response) {
                    console.log(response);
                    self.progresso = 0;
                    if (response.success) {
                        self.documentUpload = []

                        if (element.side == 'front') {
                            self.userDaCensire.documento.idImgDocumentoFront = ""
                            self.disabeldUploadFront = false;
                        } else {
                            self.userDaCensire.documento.idImgDocumentoBack = ""
                            self.disabeldUploadBack = false;
                        }

                        self.userDaCensire.documento.uploadedDoc = self.userDaCensire.documento.uploadedDoc.filter(x => {
                            return x.selected == false;
                        });

                        self.uploadOk = false;
                    }
                    self.visualProgBarDoc = false;
                })
                .catch(function (error) {
                    $rootScope.$broadcast("addAlert", {
                        text: "ERROR_TEC",
                    });
                });

        });
    }

    self.downloadFiles = function (file) {
        var url = "/uni/downloadDocAdv/service-infos/";
        var input = {
            downloadKey: file.downloadKey
        }

        $download.getGenericDownload(url, input)
            .then(function (response) {
                console.log(response)
            })
    }

    // fine sezione upload
    self.setDate = function (dataNascita, newData, tempPerson) {

        self.tempPerson[dataNascita] = newData;

    }

    self.setDocData = function (tipoData, newData) {
        self.userDaCensire.documento[tipoData] = newData;
    }

    self.setDataLettera = function (tipoData, newData) {
        self.userDaCensire[tipoData] = newData;
    }

    self.updateInfoStatoDocumento = function (value) {

        self.userDaCensire.documento.luogo = value.name;
        self.userDaCensire.documento.stato = value.name;

    }

    var createCfFromFidEsteri = () => {

        self.listPf.forEach(tempPerson => {

            if (tempPerson.isEstero && !!!tempPerson.cf) {
                var valueStato = "";
                if (!!tempPerson.datiNascita.stato && !!!tempPerson.datiNascita.stato.value && !!tempPerson.datiNascita.stato.name) {
                    var tempSato = self.listaNazioni.find(stato => {
                        return stato.name.toUpperCase() === tempPerson.datiNascita.stato.name.toUpperCase();
                    })
                    valueStato = tempSato && tempSato.value;
                } else {
                    valueStato = tempPerson.datiNascita.stato.value
                }

                if (!!!tempPerson.sesso) {
                    tempPerson.sesso = 'M'
                }

                tempPerson.cf = validationService.createCf(tempPerson.nome, tempPerson.cognome, tempPerson.data, tempPerson.sesso, valueStato)
            }
        })
    }

    var generateLinkExampleDoc = function (tipoDocumento) {
        self.linkDownloadExampleDoc = $configService.getAppConfig().url +
            '/uni/download/service-infos/' +
            encodeURIComponent(tipoDocumento) +
            '/?token=' +
            $configService.getAppConfig().token;
    }

}